// MENU - OPEN
// SCROLLING DOWN

jQuery.noConflict();
(function($) {
	$(function() {

		//CLICK CURRENT PORTFOLIO
		if( $('.portfolio-filter').length > 0 ) {
			jQuery(document).ready(function($) {
			    $('#current').click();
			});
		}

		// MENU - OPEN
		$('#mobile-menu').on('click', function() {
			console.log('clicked');
			if($('#mobile-menu .mobile-container').hasClass('mobile-open')) {
				$('#mobile-menu .mobile-container').removeClass('mobile-open');
				$('.site-header .site-nav').slideUp();
			} else {
					$('#mobile-menu .mobile-container').addClass('mobile-open');
					$('.site-header .site-nav').slideDown();
			}
		});

		// $('.menu-item-has-children > a').on('click', function(ev) {
		// 	ev.preventDefault();
		// 	var subMenu = $(this).closest('li').find('ul.sub-menu');

		// 	if(subMenu.height() > 100) {
		// 		subMenu.css('max-height','0px');
		// 	} else {
		// 		subMenu.css('max-height','350px');
		// 	}
		// });

		//QUOTE WRAP
		if($('blockquote').length > 0) {
			$('blockquote').each(function(){
				if(! $(this).parent(".quotes").length ) {
					console.log("found");
				    $(this).wrap('<div class="quotes"</div>');
				}
			});
		}

		// SCROLLING DOWN
		$('.scroll-btn').on('click', function() {
			var scroll_dest = ($('.hero-header').offset().top + $('.hero-header').height()) - $('.header-content').height();

			$('html, body').animate({ scrollTop: scroll_dest}, 300);
		});

		// MATCH HEIGHT
		if($('.address-container').length > 0) {
			$('.address-container').matchHeight();
		}
		if($('.get-in-touch-container').length > 0) {
			$('.get-in-touch-container').matchHeight();
		}

		if($('.footer-column').length > 0) {
			$('.footer-column').matchHeight();
		}

		if($('.team-filter-container ul li .details').length > 0) {
			$('.team-filter-container ul li .details').matchHeight();
		}

		if($('.news-container ul li h3').length > 0) {
			$('.news-container ul li h3').matchHeight();
		}

		if($('.text-container').length > 0) {
			$('.text-container').matchHeight();
		}
		if($('.tab-downloads li').length > 0) {
			$('.tab-downloads li').matchHeight();
		}

		//SCROLL BACK TOP
		$('.scroll-up').on('click', function() {
			$('html, body').animate({ scrollTop : 0 }, 300);
		});

		$('#scroll-down').on('click', function() {
			var header_h = $('.hero-header').offset().top + $('.hero-header').height();
			console.log(header_h);
			$('html, body').animate({ scrollTop : header_h }, 300);
		});


		//MENU HEADER SEARCH
		var header_form = $('header.site-header .header-content .search');
		header_form.find('input[type="text"]').on('focus', function() {
			header_form.addClass('hovered');
		});
		header_form.find('input[type="text"]').on('blur', function() {
			header_form.removeClass('hovered');
		});

		header_form.find('form').on('submit', function() {
			if(header_form.find('input[type="text"]').val() == '') {
				return false;
			}
		});




		// GET HEIGHT OF HIDDEN ELEMENTS
		// $('.tabs-content').each(function() {
		// 	var getH = [];
		// 	$(this).find('.tab-content').each(function() {
		// 		$(this).find($('.tab-pane')).each(function() {
		// 			var previousCss  = $(this).attr("style");
		// 			$(this).css({
		// 		        position:   'absolute',
		// 		        visibility: 'hidden',
		// 		        display:    'block'
		// 		    });
		// 		    getH.push($(this).outerHeight());
		//
		// 			$(this).attr("style", previousCss ? previousCss : "");
		// 		});
		// 	});
		// 	$(this).find('.tab-content .tab-pane').css('min-height', getH.sort(function(a, b) { return b - a; }).splice(0,1)[0] + 'px');
		// });



		// SUBNAVIGATION
		if($('.subnavigation').length > 0) {
			$('.subnavigation nav a').on('click', function(ev) {
				ev.preventDefault();
				var section_link = $(this).attr('href')
				;

	            // var checkOffset = setInterval(function() {
	            	var find_section = $(section_link).offset();
	            	$('html, body').animate({ scrollTop: find_section.top + 2}, 500);
	            	if($(window).scrollTop() + 50 >= find_section.top) {
	            		// clearInterval(checkOffset);
	            	}
	            // }, 550)
			});
			$(document).on("scroll", onScroll);
		}

		function onScroll(event){
		    var scrollPos = $(document).scrollTop();
		    var fixedNav = $('.subnavigation.fixed-nav');
		    var floatingNav = $('.subnavigation.floating-nav');

		    // if((fixedNav.position().top + fixedNav.outerHeight()) + 50 < scrollPos) {
		    // 	floatingNav.addClass('floating');
		    // } else {
		    // 	floatingNav.removeClass('floating');
		    // }

		    $('.subnavigation nav a').each(function () {
		        var currLink = $(this);
		        var refElement = $(currLink.attr("href"));
		        if ((refElement.length > 0) &&
		        	(refElement.position().top <= (scrollPos + 200)) &&
		        	(refElement.position().top + refElement.outerHeight() > scrollPos + 200)) {
		            $('.subnavigation nav a').removeClass("active");
		            currLink.addClass("active");
		        } else{
		            currLink.removeClass("active");
		        }
		    });
		}


		// SELECTS
		$('.custom-select select').each(function(){
			$(this).select2({
				minimumResultsForSearch: 20,
				// placeholder: {
			  //   id: '0', // the value of the option
				// 	text: $(this).find('option').first().html()
			  // }
			});
		});


		// PORTFOLIO CAROUSEL
		$('.carousel-inner').slick({
			dots: true,
			centerPadding: '0px',
			infinite: true,
			speed: 300,
			slidesToShow: 3,
			slidesToScroll: 1,
			lazyLoad: 'ondemand',
			autoplay: true,
			autoplaySpeed: 3500,
			responsive: [
				{
					breakpoint: 992,
					centerPadding: '0px',
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1,
						infinite: true,
						dots: true
					}
				},
				{
					breakpoint: 580,
					centerPadding: '0px',
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}
			]
		});
		$(".slick-dots").wrap("<div class=\"carousel-indicators\"></div>");
		$('.carousel-inner').on('breakpoint', function(event, slick, breakpoint){
		    $(".slick-dots").wrap("<div class=\"carousel-indicators\"></div>");
		});




		// VIDEO CAROUSEL

		$('.slick-video').on('init', function() {

			$('.video-container').find('iframe').load(function(){
				$(window).on('load resize', function() {
					$('.slick-arrow').height($('.video-container iframe').height());

					if($(window).width() < 768) {
						$('.video-indicators').css('top', 0);
					} else {
						$('.video-indicators').css('top', 0 - $('.video-content').height() - 24 );
					}
				})
			});
		});
		$('.slick-video').slick({
			dots: true,
			infinite: true,
			speed: 300,
			slidesToShow: 3,
			slidesToScroll: 1,
			lazyLoad: 'ondemand',
			autoplaySpeed: 5000,

			responsive: [
				{
					breakpoint: 992,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
					}
				}
			]
		});
		$(".slick-dots").wrap("<div class=\"video-indicators\"></div>");

		// BACK BUTTON HISTORY

		$('.back-btn').on('click','a.history',function(e){
			e.preventDefault();
			history.go(-1);
		});


	});
})(jQuery);

jQuery(window).on("orientationchange", function() {
  jQuery(window).resize();
});
